import React from 'react';
import { Button } from '@cimpress/react-components';

export type GarmentMarkersToggleProps = {
    isEditing: boolean;
    /** True when there's no scene-defining background to calibrate, or no apparel data for the
     * current product. */
    disabled?: boolean;
    disabledReason?: string;
    onToggle: () => void;
};

/**
 * Toggles the on-canvas garment marker overlay (`canvas/garmentMarkers/`) on or off.
 * Markers are dragged directly on the main canvas (inheriting canvas pan/zoom) and commit
 * to Redux upon drag completion.
 */
export default function GarmentMarkersToggle({
    isEditing,
    disabled,
    disabledReason,
    onToggle,
}: GarmentMarkersToggleProps) {
    return (
        <div className='garment-markers-toggle'>
            <span title={disabled ? disabledReason : undefined}>
                <Button disabled={disabled} variant={isEditing ? 'primary' : undefined} onClick={onToggle}>
                    {isEditing ? 'Hide Garment Markers' : 'Show Garment Markers'}
                </Button>
            </span>
            {isEditing && (
                <p className='garment-markers-toggle__hint'>
                    Drag the lines and handles directly on the canvas — changes save as you drag.
                </p>
            )}
        </div>
    );
}
